import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIFooter from 'UIComponents/panel/UIPanelFooter';

// @ts-expect-error ts-migrate(2565) FIXME: Property 'defaultProps' is used before being assig... Remove this comment to see the full error message
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function EscalationPanelFooter(props) {
  return /*#__PURE__*/_jsxs(UIFooter, {
    style: {
      padding: '1.5rem'
    },
    children: [/*#__PURE__*/_jsx(UIButton, {
      "data-test-id": "escalation-panel-footer-submit-button",
      disabled: !props.canSubmit,
      onClick: props.onSubmit,
      use: "primary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.escalations.panel.footer.submit"
      })
    }), /*#__PURE__*/_jsx(UIButton, {
      "data-test-id": "escalation-panel-footer-cancel-button",
      onClick: props.onCancel,
      use: "secondary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.escalations.panel.footer.cancel"
      })
    })]
  });
}
EscalationPanelFooter.propTypes = {
  canSubmit: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
EscalationPanelFooter.defaultProps = {
  canSubmit: false
};
export default EscalationPanelFooter;